export default __webpack_public_path__ + "static/garden_design8-7812e78ffc2926182a15ac6888c60edd.webp";